var addOrdinalSuffix = function (day) {
    if (day === undefined)
        return '';
    var suffixes = ['th', 'st', 'nd', 'rd'];
    var computation = (day > 3 && day < 21) || day % 10 > 3 ? 0 : day % 10;
    var suffix = day > 0 ? suffixes[computation] : '';
    return "".concat(day).concat(suffix);
};
export default addOrdinalSuffix;
